import { SessionStorageNewItem } from "@/src/shared/types/sessionStorage";
import { parseJsonString } from "@/src/shared/utils/index";

export const setItemToSessionStorage = (sessionStorageKey: string, value: any) => {
  window.sessionStorage.setItem(sessionStorageKey, JSON.stringify(value));
};

export const getItemFromSessionStorage = (sessionStorageKey: string) => {
  const storedItem = window.sessionStorage.getItem(sessionStorageKey);
  return storedItem ? parseJsonString(storedItem) : null;
};

export const removeItemSessionStorage = (sessionStorageKey: string) => {
  window.sessionStorage.removeItem(sessionStorageKey);
};

export const pushDataToSessionStorage = (sessionStorageKey: string, newData: SessionStorageNewItem) => {
  const storedItem = getItemFromSessionStorage(sessionStorageKey) || {};
  const newValue = { ...storedItem, ...newData };

  setItemToSessionStorage(sessionStorageKey, newValue);
};

export const removePropertySessionStorage = (sessionStorageKey: string, propertyName: string) => {
  const storedItem = getItemFromSessionStorage(sessionStorageKey);

  if (!storedItem) return;

  delete storedItem[propertyName];
  setItemToSessionStorage(sessionStorageKey, storedItem);
};
